import {notify} from '../useNotify';

import {IAfterActionProps} from './types';

/**
 * Shows the notification and runs the callback of an action (add to cart, wishlist…). A plain function:
 * call it from event handlers.
 *
 * @param {IAfterActionProps} object - Notification and callback
 */
export const runAfterAction = (object: IAfterActionProps) => {
	const {notifyContent, callback} = object;

	if (notifyContent) {
		if (notifyContent.type === 'success') {
			notify.success(notifyContent.content, notifyContent?.options);
		} else if (notifyContent.type === 'error') {
			notify.error(notifyContent.content, notifyContent?.options);
		}
	}

	if (typeof callback === 'function') {
		callback();
	}
};

/** @deprecated Not a hook (the brands call it from callbacks): use `runAfterAction`. */
const useAfterAction = runAfterAction;

export default useAfterAction;
